import React, { type FC } from 'react';
import { PageHeaderTitle } from './PageHeaderTitle';
import { DescriptionTags } from './DescriptionTags';
import { Cell, Layout, Text, Carousel } from '@wix/design-system';
import { DataHooks } from '../../../constants/dataHooks';
import css from '../TemplatePage.scss';
import { useSingleTemplateData } from '../../../hooks/useSingleTemplateData';
import { MainCTAs } from './MainCTAs';
import { useTemplatesPageBi } from '../../../hooks/useTemplatesPageBi';

export const TemplateMainCard: FC = () => {
  const { template } = useSingleTemplateData();

  const { reportImagesCarouselChange } = useTemplatesPageBi();

  return (
    <Layout dataHook={DataHooks.MainCardLayout} className={css.mainCardWrapper}>
      <Cell span={6}>
        <div className={css.templateDescriptionLayout}>
          <div className={css.titleAndDescriptionWrapper}>
            <PageHeaderTitle />
            <DescriptionTags template={template} />
            <div className={css.descriptionParagraph}>
              <Text
                size="medium"
                weight="thin"
                dataHook={DataHooks.TemplateFullDescription}
              >
                {template?.description}
              </Text>
            </div>
          </div>
          <MainCTAs />
        </div>
      </Cell>
      <Cell span={6}>
        <Carousel
          beforeChange={() => {
            reportImagesCarouselChange(template.id);
          }}
          dataHook={DataHooks.ImagesCarousel}
          controlsSize="tiny"
          imagesPosition="50% 50%"
          images={template?.images?.map((image) => ({ src: image }))}
        />
      </Cell>
    </Layout>
  );
};
